"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./Table.css");

var _Elements = require("../Elements");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Render the complete table
var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.state = {
      table_items: [],
      edit_settings: {
        active: false,
        edit: false,
        "delete": false,
        duplicate: false,
        show: true
      }
    };

    _this.translate = function (e) {
      return (0, _idbReactTranslations["default"])(e, props.lang);
    };

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          data = _this$props.data,
          deleteData = _this$props.deleteData,
          duplicateData = _this$props.duplicateData,
          editData = _this$props.editData,
          table_items = _this$props.table_items; // Check if the user has set which column is should be
      // if not, create by default a state and set all true

      var items = [];
      if (table_items && _typeof(table_items) === 'object') items = table_items;else if (data) Object.keys(data[0]).forEach(function (key) {
        items.push(key);
      });

      var state_copy = _objectSpread({}, this.state.edit_settings);

      state_copy.show = editData || deleteData ? true : false;
      state_copy.edit = editData ? true : false;
      state_copy["delete"] = deleteData ? true : false;
      state_copy.duplicate = duplicateData ? true : false;
      this.setState({
        edit_settings: state_copy,
        table_items: items,
        table_content: data
      });
    }
  }, {
    key: "activateEdit",
    value: function activateEdit(x, y, z) {
      var state_copy = _objectSpread({}, this.state.edit_settings);

      if (x === 'edit') {
        state_copy.active = state_copy.active === y ? false : y;
        this.setState({
          edit_settings: state_copy
        });
      } else if (x === 'save') {
        state_copy.active = false;
        this.setState({
          edit_settings: state_copy
        });
        this.props.editData(z);
      } else if (x === 'delete') {
        this.setState({
          alert_box: true,
          stored_to_delete: z
        });
      } else if (x === 'duplicate') {
        this.setState({
          edit_settings: state_copy
        });
        this.props.duplicateData(z);
      }
    }
  }, {
    key: "deleteOk",
    value: function deleteOk(e) {
      if (e) {
        this.props.deleteData(this.state.stored_to_delete);
      }

      this.setState({
        alert_box: false,
        stored_to_delete: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var _this$state = this.state,
          alert_box = _this$state.alert_box,
          edit_settings = _this$state.edit_settings,
          table_content = _this$state.table_content,
          table_items = _this$state.table_items;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "esnTableWrapper"
      }, alert_box && /*#__PURE__*/_react["default"].createElement(_Elements.OsnAlertBox, {
        accept_text: this.translate('am_sure'),
        cancel_text: this.translate('changed_my_mind'),
        message: this.translate('sure_you_want_to_delete'),
        onClick: function onClick(e) {
          return _this2.deleteOk(e);
        }
      }), table_content ? table_content.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.filter && /*#__PURE__*/_react["default"].createElement("div", {
        className: "tableFilter"
      }, /*#__PURE__*/_react["default"].createElement(_Elements.Button, {
        bgColor: ['main', 'sub'],
        icon: "Filter",
        size: "S",
        text: "Filter",
        txtColor: "white",
        type: "main"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "tableFilterMenuWrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "tableFilterMenu"
      }, Object.keys(table_content[0]).map(function (key, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tableFilterItem",
          key: key
        }, /*#__PURE__*/_react["default"].createElement(_Elements.OsnCheckbox, {
          checked: table_items.includes(key),
          name: key,
          onChange: function onChange() {
            var state_copy = _toConsumableArray(table_items);

            if (state_copy.includes(key)) state_copy.splice(state_copy.indexOf(key), 1);else state_copy.push(key);

            _this2.setState({
              table_items: state_copy
            });
          },
          value: _this2.translate(key)
        }));
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "esnTable",
        style: {
          height: props.filter ? 'calc(100% - 54px)' : '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement(Head, {
        data: table_content,
        editSettings: edit_settings,
        onArrowsClick: props.onArrowsClick,
        tableItems: table_items,
        translate: function translate(e) {
          return _this2.translate(e);
        }
      }), /*#__PURE__*/_react["default"].createElement(Body, {
        data: table_content,
        editData: function editData(x) {
          return props.editData(x);
        },
        editPopUp: this.props.editPopUp,
        editSettings: edit_settings,
        onClick: props.onClick,
        selected: props.selected,
        onArrowsClick: props.onArrowsClick,
        table_items: table_items,
        activateEdit: function activateEdit(x, y, z) {
          return _this2.activateEdit(x, y, z);
        }
      })))) : '' : '');
    }
  }]);

  return Table;
}(_react.Component); // Render the table head


exports["default"] = Table;

var Head = function Head(props) {
  return /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, props.onArrowsClick && /*#__PURE__*/_react["default"].createElement("th", {
    style: {
      width: '25px'
    }
  }), Object.entries(props.data[0]).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return props.tableItems.includes(key) && _typeof(value) !== 'object' && /*#__PURE__*/_react["default"].createElement("th", {
      key: key
    }, props.translate(key));
  }), props.editSettings.show && /*#__PURE__*/_react["default"].createElement("th", {
    style: {
      width: '25px'
    }
  })));
}; // Render the table body


var Body = /*#__PURE__*/function (_Component2) {
  _inherits(Body, _Component2);

  var _super2 = _createSuper(Body);

  function Body(props) {
    var _this3;

    _classCallCheck(this, Body);

    _this3 = _super2.call(this, props);
    _this3.state = {
      body_data: props.data ? props.data : []
    };
    return _this3;
  }

  _createClass(Body, [{
    key: "editBodyData",
    value: function editBodyData(index, key, value) {
      var props_copy = _toConsumableArray(this.state.body_data);

      props_copy[index][key] = value;
      this.setState({
        body_data: props_copy
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props,
          body_data = this.state.body_data;
      return /*#__PURE__*/_react["default"].createElement("tbody", null, body_data.map(function (obj, index) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          className: props.selected === index ? 'active' : '',
          key: index,
          onClick: props.onClick ? function () {
            return props.onClick(index, obj);
          } : undefined
        }, props.onArrowsClick && /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            width: '25px'
          }
        }, props.onArrowsClick( /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "ArrowRight",
          onClick: function onClick() {
            return props.onArrowsClick();
          }
        }), obj)), /*#__PURE__*/_react["default"].createElement(Cell, {
          data: obj,
          edit: props.editSettings.active === index,
          editBodyData: function editBodyData(key, value) {
            return _this4.editBodyData(index, key, value);
          },
          table_items: props.table_items
        }), props.editSettings.show && /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            width: '25px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "FlexTableRowOptions"
        }, props.editSettings.edit && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: props.editSettings.active === index ? 'Save' : 'Edit',
          onClick: function onClick() {
            return props.editPopUp ? props.editData() : props.activateEdit(props.editSettings.active === index ? 'save' : 'edit', index, obj);
          }
        }), props.editSettings.duplicate && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "Clipboard",
          onClick: function onClick() {
            return props.activateEdit('duplicate', index, obj);
          }
        }), props.editSettings["delete"] && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "Bin",
          onClick: function onClick() {
            return props.activateEdit('delete', index, obj);
          }
        }))));
      }));
    }
  }]);

  return Body;
}(_react.Component); // Render the table cell


var Cell = function Cell(_ref3) {
  var data = _ref3.data,
      edit = _ref3.edit,
      editBodyData = _ref3.editBodyData,
      table_items = _ref3.table_items;

  // Transform date formats to
  // human readable dates.
  var dateToString = function dateToString(x) {
    // Input: 2020-01-16T14:47:31.612123Z
    var date = new Date(x),
        time = date.toLocaleTimeString();
    date = date.toLocaleDateString(); // Output: 2020-01-16 at 14:47:31

    return "".concat(date, " at ").concat(time);
  };

  var valueCheck = function valueCheck(_ref4) {
    var key = _ref4.key,
        value = _ref4.value;
    return key.includes('icon') ? /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: value
    }) // String
    // Strings can have many meanings, such as:
    // Date formats, image urls, ...
    : typeof value === 'string' ? // If string is an image
    value.includes('jpg') || value.includes('jpeg') || value.includes('png') || value.includes('svg') ? edit ? 'To be implemented' : /*#__PURE__*/_react["default"].createElement("img", {
      alt: key.replace(/_/, ' '),
      src: value
    }) : // If string is a date
    key.includes('date') && new Date(value) instanceof Date && !isNaN(new Date(value)) ? edit ? /*#__PURE__*/_react["default"].createElement(_Elements.OsnInputDate, {
      onChangeDate: function onChangeDate(e) {
        return editBodyData(key, e.target.value);
      },
      value_date: new Date(value).toLocaleTimeString()
    }) : dateToString(value) // If string is anything else
    : edit ? /*#__PURE__*/_react["default"].createElement(_Elements.OsnInputText, {
      onChange: function onChange(e) {
        return editBodyData(key, e.target.value);
      },
      placeholder: key.replace(/_/, ' '),
      value: value
    }) : value // Object or array
    // Ignore, show empty value
    : _typeof(value) === 'object' ? '' // Boolean
    // Show by default checkbox.
    // Disabled or enabled depending on edit state
    : typeof value === 'boolean' ? /*#__PURE__*/_react["default"].createElement(_Elements.OsnCheckbox, {
      disabled: !edit && key !== 'is_active',
      checked: value,
      name: "boolean_".concat(key),
      onChange: function onChange(e) {
        return editBodyData(key, !value);
      }
    }) // Number
    // Non-edit: Show value
    // Edit: Show input field
    : typeof value === 'number' ? edit ? /*#__PURE__*/_react["default"].createElement(_Elements.OsnInputText, {
      onChange: function onChange(e) {
        return editBodyData(key, Number(e.target.value));
      },
      placeholder: key.replace(/_/, ' '),
      type: "number",
      value: value
    }) : value // Something else
    // N.A.
    : 'n.a.';
  };

  return Object.entries(data).map(function (_ref5, index) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return table_items.includes(key) && _typeof(value) !== 'object' && /*#__PURE__*/_react["default"].createElement("td", {
      key: index
    }, valueCheck({
      key: key,
      value: value
    }));
  });
};